import { jsx as r } from "react/jsx-runtime";
import o from "./index.es5470.js";
import { LabelContainer as e } from "./index.es5471.js";
const n = ({ children: t }) => /* @__PURE__ */ r("div", { className: o["card--content"], "data-type": "card-content", children: t });
n.LabelsContainer = e;
export {
  n as CardContent
};
//# sourceMappingURL=index.es683.js.map
